import Vue from 'vue';
import axios from 'axios';
import store from './store';

const DOMAIN_API = process.env.DOMAIN_API;
const API_URI = `${DOMAIN_API}/api`;
console.log(`API_URI=${API_URI}`);
global.DOMAIN_API = DOMAIN_API;
global.API_URI = API_URI;
axios.defaults.baseURL = API_URI;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.request.use((config) => {
  if (store.getters.isAuthenticated) {
    const auth = store.getters.getAuth;
    // eslint-disable-next-line
    config.headers.Authorization = `${auth.token_type} ${auth.access_token}`;
  } else {
    const username = 'QrApp';
    const password = 'c4q3r3pya6at4mqxzevnzwwr8wsnbyg2d8j3gntk';
    const btoaStr = btoa(`${username}:${password}`);
    const basicAuth = `Basic ${btoaStr}`;
    // eslint-disable-next-line
    config.headers.Authorization = basicAuth;
  }
  return config;
});

Vue.prototype.$http = axios;

export default axios;



// WEBPACK FOOTER //
// ./src/http.js